/* global $ */
/* global document */
export default (authInfo, authHandler) => ({
  init() {
    $.ajaxPrefilter((options, originalOptions, xhr) => {
      xhr.setRequestHeader('Authorization', `Bearer ${authInfo.getAccessToken()}`);
    });
    $(document).ajaxError((event, xhr) => {
      authHandler.handle(xhr.status);
    });
  },
});



/** WEBPACK FOOTER **
 ** ./src/filter.js
 **/